import React from "react";
import { Formik } from "formik";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/other/Loader";
import HeroSection from "../../layout/HeroSection";
import { pageRoutes } from "../../routes/pageRoutes";
import { contactUsSchema } from "../../utils/schema";
import { useDispatch, useSelector } from "react-redux";
import ErrorMessage from "../../components/ErrorMessage";
import { contactUs } from "../../redux/action/homeAction";

const ContactUs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialState = {
    name: "",
    email: "",
    message: "",
    subject: "",
  };
  const { isLoading } = useSelector((state) => state?.homeReducer);

  const handleContactUs = async (values) => {
    const callback = (response) => {
      if (response.success) navigate(`${pageRoutes?.home}/`);
    };

    dispatch(
      contactUs({
        payload: values,
        callback,
      }),
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Contact Us"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Contact Us", path: `${pageRoutes?.home}/` },
        ]}
        subtitle={
          "We’re an energetic, hard-working team of education professionals, aiming to move education and technology forward. If you’re interested in working with us, please send us a message!"
        }
      />
      <div class="untree_co-section">
        <div class="container">
          <div class="block">
            <div class="row justify-content-center">
              <div class="col-md-10 col-lg-10">
                <div class="row mb-5 justify-content-center">
                  <div class="col-lg-4">
                    <div class="service no-shadow align-items-center link horizontal d-flex active mb-4">
                      <div class="service-icon color-1 ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-envelope-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z" />
                        </svg>
                      </div>{" "}
                      {/*/.icon */}
                      <div class="service-contents">
                        <a
                          href="mailto:AdvancedLearningProject@gmail.com"
                          class="mb-0"
                        >
                          AdvancedLearningProject@gmail.com
                        </a>
                      </div>{" "}
                      {/*/.service-contents*/}
                    </div>{" "}
                    {/*/.service */}
                  </div>

                  <div class="col-lg-4">
                    <div class="service no-shadow align-items-center link horizontal d-flex active mb-4">
                      <div class="service-icon color-1 ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-telephone-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                          />
                        </svg>
                      </div>{" "}
                      {/*/.icon */}
                      <div class="service-contents">
                        <a href="tel:+3104284728" class="mb-0">
                          +310-428-4728
                        </a>
                      </div>{" "}
                      {/*/.service-contents*/}
                    </div>{" "}
                    {/*/.service */}
                  </div>
                </div>
                <Formik
                  initialValues={initialState}
                  validationSchema={contactUsSchema}
                  onSubmit={(values) => {
                    handleContactUs(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    setFieldValue,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_contact_form">
                      <div>
                        <div class="ct_section_title">
                          <h2 class="section-title mb-4 text-center">
                            <strong>Contact Us</strong>
                          </h2>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="ct_input-group mb-3">
                            <input
                              required=""
                              type="text"
                              name="name"
                              id="name"
                              placeholder="Enter full name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                              autocomplete="off"
                              class="ct_input"
                            />
                            <label class="ct_user-label">Full Name</label>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="name"
                            />
                            {/*<p class="ct_error_text">Please Enter First Name</p> */}
                          </div>
                        </div>
                      </div>
                      <div class="ct_input-group mb-3">
                        <input
                          required=""
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Enter email "
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          autocomplete="off"
                          class="ct_input"
                        />
                        <label class="ct_user-label">Email</label>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="email"
                        />
                        {/*<p class="ct_error_text">Please Enter Email</p> */}
                      </div>
                      <div class="ct_input-group mb-3">
                        <input
                          required=""
                          type="text"
                          name="subject"
                          placeholder="Enter subject"
                          id="subject"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.subject}
                          autocomplete="off"
                          class="ct_input"
                        />
                        <label class="ct_user-label">Subject</label>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="subject"
                        />
                        {/*<p class="ct_error_text">Please Enter Email</p> */}
                      </div>

                      <div class="ct_input-group mb-5">
                        <textarea
                          rows="4"
                          required=""
                          id="message"
                          placeholder="Enter message"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.message}
                          autocomplete="off"
                          class="ct_input"
                        ></textarea>
                        <label class="ct_user-label">Message</label>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="message"
                        />
                        {/*<p class="ct_error_text">Please Enter Email</p> */}
                      </div>

                      <button
                        type="button"
                        onClick={handleSubmit}
                        class="btn btn-secondary ct_btn_animate mx-auto d-block"
                      >
                        Send Message
                      </button>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
